import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { RepresentanteMultiselectModule } from '../../pessoa/representante/multiselect';

import { MetaFilterComponent } from './meta-filter.component';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteMultiselectModule
    ],
    declarations: [
        MetaFilterComponent
    ],
    exports: [
        MetaFilterComponent
    ]
})
export class MetaFilterModule { }
